import type {
  IPieChartSourceData,
  ILineChartHistorySourceData,
  ILineChartSourceData,
} from '@/pages/intelligence/components/Chart/types';
import type {
  ITopChartsCompaniesRank,
  ITopChartsCompaniesTimeline,
  ITopChartsCompaniesTrend,
  ITopChartsTypeOfCompanies,
} from '@/pages/intelligence/pages/TopCharts/Companies/components/CompaniesCore/types';
import { ITopChartsCompaniesSourceMetric } from '@/pages/intelligence/pages/TopCharts/Companies/components/CompaniesCore/types';

const METRIC_KEYS_MAPPING: {
  [key in ITopChartsTypeOfCompanies]: string;
} = {
  top_companies_revenue: 'total_revenue',
  top_companies_downloads: 'downloads',
  top_companies_mentions: 'mentions',
};

const getMetricByTopChartsType = (
  metrics: ITopChartsCompaniesSourceMetric[],
  topChartsType: ITopChartsTypeOfCompanies,
): ITopChartsCompaniesSourceMetric | undefined => {
  const metricKey = METRIC_KEYS_MAPPING[topChartsType];
  return metrics?.find((item) => item?.metric === metricKey);
};

export const mapBarOrPieMetricsData = (
  topChartsType: ITopChartsTypeOfCompanies,
  data: ITopChartsCompaniesRank,
): IPieChartSourceData => {
  const { app_id: appId, name, image_url: imageUrl, source_metric_list: metrics } = data ?? {};
  const metric = getMetricByTopChartsType(metrics, topChartsType);
  return {
    app_id: appId ?? '',
    name: name ?? '',
    cover: imageUrl ?? '',
    value: metric?.value ?? Number.NaN,
  };
};
const handleHistories = (
  topChartsType: ITopChartsTypeOfCompanies,
  data: ITopChartsCompaniesTimeline[],
): ILineChartHistorySourceData[] => {
  if (!Array.isArray(data)) return [];
  return data.filter((item) => item?.time).map((item) => mapHistory(topChartsType, item));
};

const mapHistory = (
  topChartsType: ITopChartsTypeOfCompanies,
  data: ITopChartsCompaniesTimeline,
): ILineChartHistorySourceData => {
  const { time, metric_value_list: metrics } = data ?? {};
  const metric = getMetricByTopChartsType(metrics, topChartsType);
  return {
    time: time ?? '',
    source: metric?.data_source ?? '',
    metric: metric?.metric ?? '',
    value: metric?.value?.toString() ?? '',
  };
};

export const mapTrend = (
  topChartsType: ITopChartsTypeOfCompanies,
  data: ITopChartsCompaniesTrend,
): ILineChartSourceData => {
  const { id, name, image_url: imageUrl, time_line: timelines } = data ?? {};
  const histories = handleHistories(topChartsType, timelines);
  return {
    id: id ?? '',
    name: name ?? '',
    cover: imageUrl ?? '',
    history: histories,
  };
};
